import {
    useQueryPromise,
    fetchPostQuery,
    setAuthorizationToken,
    removeAuthorizationToken,
    checkAuthorizationToken,
} from '/src/api';
import graphQLQueries from './graph-ql-queries';

const useAuth = () => {
    const {
        data: isAuth,
        isLoading: isLoadingAuth,
        setValues,
    } = useQueryPromise({ data: checkAuthorizationToken() });

    const login = (variables, headers) => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.generateCustomerToken,
            variables,
            headers,
        }).then(response => {
            const { generateCustomerToken: { token } } = response;
            setAuthorizationToken(token);
            setValues({ data: !!token, isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        });
    };

    const loginOtp = (variables, headers) => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.verifyPasswordOtp,
            variables,
            headers,
        }).then(response => {
            const { verifyPasswordOtp: { token } } = response;
            setAuthorizationToken(token);
            setValues({ data: !!token, isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        });
    };

    const logout = () => {
        setValues({ isLoading: true });

        fetchPostQuery({
            query: graphQLQueries.revokeCustomerToken
        }).then(() => {
            removeAuthorizationToken();
            setValues({ data: false, isLoading: false });
        }).catch(() => {
            removeAuthorizationToken();
            setValues({ data: false, isLoading: false });
        });
    };

    const sendCaptchaQuery = (query, variables, headers) => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query,
            variables,
            headers,
        }).then(response => {
            setValues({ isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        });
    };

    const sendQuery = (query, variables) => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query,
            variables,
        }).then(response => {
            setValues({ isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        });
    };

    const setAuthToken = token => {
        setAuthorizationToken(token);
        setValues({ data: !!token });
    };

    const createCustomer = (variables, headers) => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.createCustomer,
            variables,
            headers,
        }).then(response => {
            const { createCustomerV2: { token } } = response;
            setAuthorizationToken(token);
            setValues({ data: !!token, isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        });
    };

    const requestPasswordResetEmail = (variables, headers) => sendCaptchaQuery(graphQLQueries.requestPasswordResetEmail, variables, headers);

    const resetPassword = (variables, headers) => sendCaptchaQuery(graphQLQueries.resetPassword, variables, headers);

    const changeCustomerPassword = variables => sendQuery(graphQLQueries.changeCustomerPassword, variables);

    const updateCustomerEmail = variables => sendQuery(graphQLQueries.updateCustomerEmail, variables);

    const updateCustomer = variables => sendQuery(graphQLQueries.updateCustomer, variables);

    const requestPasswordOtp = (variables, headers) => sendCaptchaQuery(graphQLQueries.requestPasswordOtp, variables, headers);

    return {
        isAuth,
        isLoadingAuth,
        login,
        logout,
        createCustomer,
        requestPasswordResetEmail,
        resetPassword,
        changeCustomerPassword,
        updateCustomerEmail,
        updateCustomer,
        setAuthToken,
        requestPasswordOtp,
        loginOtp,
    };
};

export default useAuth;
